import { render } from "./ShowPanels.vue?vue&type=template&id=ee922f90"
import script from "./ShowPanels.vue?vue&type=script&lang=js"
export * from "./ShowPanels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__